<template>
    <div class="contact">
        <div class="box_">
            <img src="../assets/icons/mail.svg" class="icon"/>
            <div class="contact-link">wonganichipofya98@gmail.com</div>
        </div>
        <div class="box_">
            <img src="../assets/icons/map-pin.svg" class="icon"/>
            <div class="contact-link">Blantyre, Malawi</div>
        </div>
        <div class="foot-heading">
            Socials
        </div>
        <div class="box_">
            <img src="../assets/icons/github-copy.svg" class="icon"/>
            <a href="https://github.com/Helixmw" target="_blank" class="contact-link">github.com/Helixmw</a>
        </div>
        <div class="box_">
            <img src="../assets/icons/logo-linkedin-copy.svg" class="icon"/>
            <a href="https://linkedin.com/in/helixwchipofya" target="blank" class="contact-link">linkedin.com/in/helixwchipofya</a>
        </div>
    </div>
</template>
<style scoped>

    .foot-heading{
        margin-top:1.4rem;
    }
    .contact-link{
        color:white;
        font-size:0.8rem;
        text-decoration: none;
    }
    

    .icon{
        height:1.4rem;
        margin-right: 0.5rem;
    }

    .box{
        display: flex;
        align-items: center;
        margin-bottom: 0.8rem;
    }

    .link{
        cursor:pointer;
    }
</style>